import { render, staticRenderFns } from "./EditClinicNoNote.vue?vue&type=template&id=6c1f61a6&scoped=true"
import script from "./EditClinicNoNote.vue?vue&type=script&lang=js"
export * from "./EditClinicNoNote.vue?vue&type=script&lang=js"
import style0 from "./EditClinicNoNote.vue?vue&type=style&index=0&id=6c1f61a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f61a6",
  null
  
)

export default component.exports